import { useContext } from 'react'
import { WebpContext } from '../context/webp'

const useWebpImage = (webpImg: string, fallbackImg: string): string => {
  const webp = useContext(WebpContext)
  return webp ? webpImg : fallbackImg
}

export default useWebpImage
